import Enum from './Enum';

export const LiveViewTabs = new Enum({
    Orders: 'tasks',
    Trips: 'tours',
    Riders: 'riders'
});

export const TripViews = new Enum({
    Details: 'details',
    Timeline: 'timeline'
});

export const SingleTripViews = new Enum({
    Orders: 'tasks',
    Timeline: 'timeline'
});

export const OrderStatusEnum = new Enum({
    All: 'all',
    Ongoing: 'ongoing',
    Completed: 'completed',
    Cancelled: 'cancelled',
    Waiting: 'waiting'
});

export const TripStatusEnum = new Enum({
    All: 'all',
    Ongoing: 'ongoing',
    Completed: 'completed',
    Delayed: 'delayed',
    Queued: 'queued',
    Waiting: 'waiting'
});

export const RiderStatusEnum = Object.freeze({
    AllActive: 'allActive',
    Delivering: 'delivering',
    Offline: 'offline',
    Available: 'available',
    Unavailable: 'unavailable',
    AllWorking: 'allWorking'
});

export const RiderStatusFilterEnum = Object.freeze({
    [RiderStatusEnum.Delivering]: 'DELIVERING',
    Others: 'OTHERS',
    [RiderStatusEnum.Offline]: 'OFFLINE',
    [RiderStatusEnum.Available]: 'AVAILABLE',
    [RiderStatusEnum.Unavailable]: 'UNAVAILABLE',
    [RiderStatusEnum.AllWorking]: 'ACTIVE'
});

export const TripStatusFilterEnum = new Enum({
    [TripStatusEnum.Ongoing]: 'STARTED',
    [TripStatusEnum.Completed]: 'COMPLETED',
    [TripStatusEnum.Delayed]: 'DELAYED',
    [TripStatusEnum.Queued]: 'QUEUED',
    [TripStatusEnum.Waiting]: 'UNASSIGNED'
});

export const OrderStatusFilterEnum = new Enum({
    [OrderStatusEnum.Ongoing]: 'ONGOING',
    [OrderStatusEnum.Completed]: 'COMPLETED',
    [OrderStatusEnum.Cancelled]: 'CANCELLED',
    [OrderStatusEnum.Waiting]: 'WAITING'
});

export const TripOrderStatusFilterEnum = new Enum({
    [OrderStatusEnum.Ongoing]: 'started',
    [OrderStatusEnum.All]: 'total',
    [OrderStatusEnum.Completed]: 'completed',
    [OrderStatusEnum.Cancelled]: 'cancelled',
    [OrderStatusEnum.Waiting]: 'queued'
});

export const IncludeTypeEnum = new Enum({
    Counts: 'COUNTS',
    Fleet: 'FLEET',
    Location: 'LOCATION',
    CrossDock: 'CROSSDOCK',
    Events: 'EVENTS',
    Routes: 'ROUTES'
});

export const PrimaryFleetEnum = new Enum({
    Rider: 'RIDER',
    Vehicle: 'VEHICLE'
});

export const SlaStatusEnum = new Enum({
    OnTime: 'ON_TIME',
    Late: 'LATE',
    NotApplicable: 'NOT_APPLICABLE'
});

export const MetricTypeEnum = new Enum({
    Distance: 'distance',
    Duration: 'time',
    Tasks: 'tasks',
    Weight: 'weight',
    Volume: 'volume'
});

export const StaticResourceKeysEnum = new Enum({
    Distance: 'travel-distance',
    Duration: 'travel-duration',
    Tasks: 'task'
});

export const SelectedRouteEnum = new Enum({
    Planned: 'PLANNED',
    Executed: 'EXECUTED'
});

export const BusyReasonEnum = new Enum({
    NeverLoggedIn: 'NEVER_LOGGED_IN',
    LoggedOut: 'LOGGED_OUT',
    LocationMissing: 'LOCATION_MISSING',
    Offline: 'OFFLINE',
    BusyManual: 'BUSY_MANUAL'
});

export const SortingInfoEnum = new Enum({
    name: 'string',
    order: 'string'
});

export const BreachTypeEnum = new Enum({
    SKILLS_BREACH: 'SKILLS_BREACH',
    SLA_BREACH_CURRENT_ORDER: 'SLA_BREACH_CURRENT_ORDER',
    SLA_BREACH_EXISTING_ORDERS: 'SLA_BREACH_EXISTING_ORDERS'
});

export const HeaderColumnTypeEnum = new Enum({
    Customer: 'Customer',
    Homebase: 'Homebase'
});

export const TripViewParamsEnum = new Enum({
    [TripViews.Timeline]: 'GANTT',
    [TripViews.Details]: null // If selected view is details, no view param expected from BE
});

export const GanttTypeEnum = new Enum({
    Planned: 'planned',
    Executed: 'executed'
});

export const TabularTaskVisitTypeEnum = new Enum({
    Homebase: 'HOMEBASE',
    Pickup: 'PICKUP',
    Drop: 'DROP',
    Service: 'SERVICE'
});

export const v2ScreenNames = new Enum({
    Tasks: 'v2 - Tasks',
    Tours: 'v2 - Tours',
    SingleTour: 'v2 - Single Tour',
    TaskDetails: 'Task Details'
});

export const v1ScreenNames = new Enum({
    TaskTable: 'v1 - Tasks Table',
    RiderTable: 'v1 - Riders Table',
    SingleRider: 'v1 - Single Rider'
});

export const v2ScreensUrlEnums = new Enum({
    Tasks: '/client/:clientId/live_view/tasks',
    Tours: '/client/:clientId/live_view/tours',
    SingleTour: '/client/:clientId/live_view/tour'
});

export const v1ScreensUrlEnums = new Enum({
    LiveView: '/client/:clientId/live_view',
    SingleRider: '/client/:clientId/user/:userId'
});

export const TourTypeEnum = new Enum({
    Planned: 'planned',
    Executed: 'executed'
});

export const SortDirections = Object.freeze({
    Asc: 'ASC',
    Desc: 'DESC'
});

export const CustomerVisitStatusFilterEnum = new Enum({
    Waiting: 'WAITING',
    Queued: 'QUEUED',
    Travelling: 'TRAVELLING',
    Transacting: 'TRANSACTING',
    Completed: 'COMPLETED',
    Cancelled: 'CANCELLED'
});

export const CrossDockStatusFilterEnum = new Enum({
    Received: 'RECEIVED',
    Waiting: 'WAITING',
    Accepted: 'ACCEPTED',
    Started: 'STARTED',
    Completed: 'COMPLETED',
    Cancelled: 'CANCELLED'
});

export const ApiIdEnum = Object.freeze({
    Orders: LiveViewTabs.Orders,
    Trips: LiveViewTabs.Trips,
    SingleTripTasks: 'single_trip_tasks',
    Riders: 'riders',
    Rider: 'rider',
    Vehicle: 'vehicle',
    Transporter: 'transporter',
    Location: 'location'
});

export const ShowLiveViewDataByEnum = Object.freeze({
    DISPATCH_DATE: 'DISPATCH_DATE',
    CURRENT_STATUS: 'CURRENT_STATUS'
});
